import { DropdownActionConfig, PrimaryActionsConfig } from "Components/General/DetailListActions";
import { useNavigate, useParams } from "react-router";
import { EmailDetails } from "../Shared/EmailDetails";
import { emailSearchStore } from "../Stores/EmailSearchStore";

interface EmailSearchResultsDetailsProps {
  actionsConfig: { primaryActions: PrimaryActionsConfig[]; dropdownActions?: DropdownActionConfig[] };
}

export const EmailSearchResultsDetails = ({ actionsConfig }: EmailSearchResultsDetailsProps) => {
  const navigate = useNavigate();
  const { id: emailId } = useParams();
  const emailData = emailSearchStore.data.find((item) => item.id === emailId) || {};

  return (
    <EmailDetails
      goBack={() => navigate(-1)}
      {...actionsConfig}
      updateEmailData={() => ""}
      type={emailData.type}
      projectSpecific={emailData.projectSpecific}
    />
  );
};
